
<input
  type="text"
  class="calender-input"
  ngxDaterangepickerMd
  [(ngModel)]="selected"
  autocomplete="off"
  [locale]="{applyLabel: 'Apply',  separator: ' To ',format: 'DD/MM/YYYY HH:mm a'}"
  [showCancel]="true"
  startKey="start"
  endKey="end"
  name="daterange"
  timePicker="true"
  (rangeClicked)="rangeClicked($event)"
  (datesUpdated)="datesUpdated($event)"
  placeholder="Select Date Range"
  (keypress)="$event.preventDefault()"
  
/>
<!-- [drops]="drops" -->
<em class="pi pi-calendar"></em>
